<wj-tab-panel #tabPanel [selectedIndex]="1" [isAnimated]="true" class="custom-tab tabs-left full-size-ver" style="flex: 1"
              appWjTabStatePersist tabStateKey="app-dev-tools">
    <wj-tab>
        <a>Connection</a>
        <div>
            <div>
                <h2>Connection to services</h2>
                <p>
                    This page allows you to connect to the Kotlin and Python services that provide various functionalities for the application.
                    You can select the environment for each service from the dropdown lists below.
                <p>
                    The following environments are available:
                <ul>
                    <li><b>Localhost:</b> run the services on your machine on ports 8080 (Kotlin) and 8000 (Python)</li>
                    <li><b>Development:</b> communicates with https://dev-*.generali.co.uk</li>
                    <li><b>Etractive:</b> communicates with https://*.k3s1.etractive.de</li>
                    <li><b>Pre-Production:</b> communicates with https://preprod-*.generali.co.uk</li>
                    <li><b>Production</b> communicates with https://*.generali.co.uk</li>
                </ul>
                <div class="labeled-data-panel" style="width: max-content" [formGroup]="connectionSettingsForm">
                    <label class="centered">Kotlin Service</label>
                    <div>
                        <wj-combo-box [displayMemberPath]="'name'" selectedValuePath="environment"
                                      [itemsSource]="environments" formControlName="kt"
                                      [placeholder]="'Default'" [isRequired]="false"
                        >
                        </wj-combo-box>
                    </div>

                    <label class="centered">Python Service</label>
                    <div>
                        <wj-combo-box [displayMemberPath]="'name'" selectedValuePath="environment"
                                      [itemsSource]="environments" formControlName="py"
                                      [placeholder]="'Default'" [isRequired]="false"
                        >
                        </wj-combo-box>
                    </div>

                    <label class="centered">Change Check Frequency</label>
                    <div>
                        <wj-input-number formControlName="changeCheckFrequency" [step]="10_000">
                        </wj-input-number><span style="margin-left: 5px">ms</span>
                        <fluent-button style="margin-left: 5px" (click)="onRunChangeDetection()">Check Now</fluent-button>
                    </div>

                    <label class="centered">GZip Request Data</label>
                    <div>
                        <fluent-switch ngChkboxDefaultControl formControlName="gzipRequests">Enable</fluent-switch>
                    </div>
                </div>
                <div class="toolbar-horizontal">
                    <fluent-button (click)="onConnectToDefaultEnvironments()" [disabled]="!ApiConfiguration.envApiKt() && !ApiConfiguration.envApiPy()">
                        <i class="fas fa-house-laptop"></i> Defaults
                    </fluent-button>
                    <fluent-button (click)="onApplyConnectionSettings()" [disabled]="connectionSettingsFormIsNotDirty()">
                        <i class="fas fa-save-circle-xmark"></i> Apply
                    </fluent-button>
                </div>
            </div>
        </div>
    </wj-tab>

    <wj-tab>
        <a>Permissions</a>
        <div [formGroup]="permissionsForm">
            <div class="layout-vbox">
                <h2>User Roles & Permissions</h2>

                <fluent-switch #usePermissionsSwitch ngChkboxDefaultControl formControlName="customPermissions">
                    Use Custom Permissions
                </fluent-switch>

                <app-admin-user-permissions [lobs]="pfData.lobs" [offices]="pfData.offices"
                                            [(appRoleAndPermissions)]="permissions"
                                            (onApply)="this.onApplyAppRolePermissions($event)"
                                            style="margin-top: 10px"
                                            [class.pseudo-disabled]="!permissionsForm.value.customPermissions"
                >
                </app-admin-user-permissions>
            </div>

        </div>
    </wj-tab>

    <wj-tab>
        <a>Py Formulas</a>
        <div>
            <div class="layout-vbox" style="gap: 10px; align-items: stretch">
                <h2>Account Page Formula Configuration</h2>
                <wj-flex-grid #accountFormulasGrid style="max-height: 600px; width: 800px"
                              [autoGenerateColumns]="false"
                              [headersVisibility]="Wijmo.HeadersVisibility.Column"
                              [allowResizing]="Wijmo.AllowResizing.Columns"
                              [allowSorting]="Wijmo.AllowSorting.SingleColumn"
                              (initialized)="onAccountFormulasGridInit(accountFormulasGrid)"
                >
                    <wj-flex-grid-filter #gridFilter></wj-flex-grid-filter>
                </wj-flex-grid>
                <wj-flex-grid-search #gridSearch style="width: 800px"
                                     placeholder="Search key(s)"
                                     [grid]="accountFormulasGrid">
                </wj-flex-grid-search>
                <div class="toolbar-horizontal" style="width: 100%">
                    <fluent-button (click)="generateAccountJson()"><i class="far fa-code"></i> Data as JSON</fluent-button>
                    <fluent-button (click)="generateAccountPython()"><i class="far fa-binary"></i> Data as Python</fluent-button>
                    <fluent-button routerLink="../dev/sheet"><i class="far fa-file-excel"></i> Sheet View</fluent-button>

                </div>
            </div>
        </div>
    </wj-tab>

    <wj-tab>
        <a>Performance</a>
        <div>
            <app-app-devtools-performance></app-app-devtools-performance>
        </div>
    </wj-tab>

</wj-tab-panel>
